module.exports = __webpack_public_path__ + "static/wlogo-e7193f6904604d6fcf100e4da1fc0a67.svg";